class PredictiveSearch extends HTMLElement {
	constructor() {
		super()

		this.input = this.querySelector('#search-input')
		this.predictiveSearchResults = document.querySelector('#search-results')

		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event)
			}, 300).bind(this)
		)
	}

	onChange() {
		const searchTerm = this.input.value.trim()

		if (!searchTerm.length) {
			$(this.predictiveSearchResults).fadeOut(function () {
				$('.search__initial').fadeIn()
			})

			return
		}

		this.getSearchResults(searchTerm)
	}

	getSearchResults(searchTerm) {
		fetch(
			`/search/suggest?q=${searchTerm}&resources[type]=product,article&resources[limit]=5&section_id=predictive-search`
		)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status)
					this.close()

					throw error
				}

				return response.text()
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('#shopify-section-predictive-search').innerHTML
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				
				if( $(this.predictiveSearchResults).find('.shop-card').length == 0 ) {
					$('.search__message').addClass('active');
				} else {
					$('.search__message').removeClass('active');
				}

				if ($('.search__initial').is(':visible')) {
					$(this.predictiveSearchResults).hide()

					$('.search__initial').fadeOut(() => {
						this.open()
					})
				} else {
					this.open()
				}
			})
			.catch((error) => {
				this.close()
				throw error
			})



			
			fetch(
				`/search?q=${searchTerm}&type=product&options[unavailable_products]=hide&options[prefix]=last&view=count`
			)
				.then((response) => {
					if (!response.ok) {
						var error = new Error(response.status)
						this.close()

						throw error
					}

					return response.text()
				})
				.then((text) => {
					$('#search-count').hide().text(text).fadeIn();
					
				})
				.catch((error) => {
					this.close()
					throw error
				})
		
	}

	open() {
		$(this.predictiveSearchResults).fadeIn()
	}

	close() {
		$(this.predictiveSearchResults).fadeOut()
	}

	debounce(fn, wait) {
		let t
		return (...args) => {
			clearTimeout(t)
			t = setTimeout(() => fn.apply(this, args), wait)
		}
	}
}

customElements.define('predictive-search', PredictiveSearch)
